module.exports = __webpack_public_path__ + "static/media/checkbox0_dark.af0707c1.svg";